<template>
  <div class="detail">
    <vannav></vannav>
    <div class="ban">
      <span class="text">
        {{ infodetail.content }}
      </span>
      <span>
        <van-tag
          color="rgba(70, 122, 255, .2)"
          text-color="rgba(70, 122, 255, 1)"
          type="primary"
          >{{ infodetail.branchName }}</van-tag
        >
        <span>{{ infodetail.createTime }}</span>
      </span>
    </div>
    <div class="ban1">
      <div>
        <div class="picker">
          <div>是否处理</div>
          <div>
            <van-field
              :disabled="defValue"
              :value="value"
              border
              clickable
              label-width="130"
              name="picker"
              placeholder="点击选择处理"
              readonly
              @click="showPicker = true"
            />
            <img :src="require('../assets/home/down.png')" alt="" />
          </div>
          <van-popup v-if="!defValue" v-model="showPicker" position="bottom">
            <van-picker
              :columns="columns"
              :disabled="defValue"
              show-toolbar
              @cancel="showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
        </div>
        <div class="textarea">
          <div>备注：</div>
          <div>
            <van-field
              v-model="remark"
              :disabled="edit_disabled"
              autosize
              border
              maxlength="60"
              placeholder="请输入备注"
              rows="2"
              show-word-limit
              type="textarea"
            />
          </div>
        </div>
      </div>
      <div class="but">
        <van-button plain size="small" type="info" @click="bank"
          >返回</van-button
        >
        <van-button
          :disabled="defValue"
          size="small"
          type="primary"
          @click="submit()"
          >提交</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { warnDetail, warnUpdate } from "@/api/home";
import { Dialog } from "vant";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      value: "未处理",
      columns: ["已处理", "未处理", "待处理"],
      showPicker: false,
      remark: "",
      infodetail: {},
      edit_disabled: false,
      defValue: false,
      fileList: [],
    };
  },
  mounted() {
    this.getWarnLog();
    this.$store.commit("changesafely", { tag: true });
  },
  methods: {
    ...mapActions({
      ActionwarnLogMessage: "warnLog/ActionwarnLogMessage",
    }),
    afterRead(file) {
      console.log(file);
      console.log(this.fileList);
      file.status = "uploading";
      file.message = "上传中...";
      setTimeout(() => {
        file.status = "done";
        file.message = "上传完成";
      }, 1000);
    },

    getWarnLog() {
      warnDetail(this.$route.query.id)
        .then((res) => {
          if (res.data.code === 200) {
            this.infodetail = res.data.data;
            this.remark = this.infodetail.remark;
            // if (this.infodetail.status === 1) {
            //   this.edit_disabled = true;
            //   this.defValue = true;
            // 	this.value = "是";
            // }
            switch (this.infodetail.status) {
              case 0:
                this.value = "未处理";

                break;
              case 1:
                this.edit_disabled = true;
                this.defValue = true;
                this.value = "已处理";
                break;
              case 2:
                this.value = "待处理";
                break;
            }
          }
        })
        .catch((err) => {});
    },
    bank() {
      this.$router.go(-1);
      this.$store.commit("changesafely", {
        tag: false,
      });
    },
    onConfirm(value) {
      this.value = value;
      if (this.value === "已处理") {
        this.infodetail.status = 1;
      } else if (this.value === "待处理") {
        this.infodetail.status = 2;
      } else {
        this.infodetail.status = 0;
      }
      this.showPicker = false;
    },
    submit() {
      Dialog.confirm({
        title: "提醒",
        message: "您真的要提交吗？",
      }).then(() => {
        warnUpdate(
          this.$token,
          this.$route.query.id,
          this.infodetail.status,
          this.remark
        )
          .then((res) => {
            if (res.data.code === 200) {
              this.ActionwarnLogMessage();
              this.$router.go(-1);
              this.$store.commit("changesafely", {
                status: this.infodetail.status,
                remark: this.remark,
                tag: true,
              });
            }
          })
          .catch((err) => {});
      });
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  width: 100%;
  height: 100%;
  background-color: #f4f6fa;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .ban1 {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 1rem;
  }
}

.ban {
  width: 100%;
  height: 2rem;
  margin-bottom: 0.2rem;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 0.1rem 0.2rem;
  box-sizing: border-box;

  & > span:nth-child(1) {
    width: 100%;
    text-align: left;
    //强制换行
    word-break: break-all;
    word-wrap: break-word;
    line-height: 0.6rem;
    font-weight: bold;
    letter-spacing: 0.01rem;
  }

  & > span:nth-child(2) {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 0.3rem;

    & > span:last-child {
      color: #b4b4b4ff;
    }
  }
}

.picker {
  background-color: #ffffff;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 0 0.2rem;
  box-sizing: border-box;
  margin-bottom: 0.2rem;
  position: relative;

  & > div:first-child {
    flex: 1;
    width: 70%;
    text-align: left;
  }

  & > div:nth-child(2) {
    width: 25%;
    text-align: right;

    img {
      left: 90%;
      top: 37%;
      width: 0.3rem;
      height: 0.3rem;
      position: absolute;
      z-index: 10000;
    }
  }
}

.textarea {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0.3rem 0.2rem;
  box-sizing: border-box;

  & > div:nth-child(2) {
    margin-top: 0.3rem;
    width: 100%;
    height: 150px;
    position: relative;

    .van-field {
      opacity: 0.6;
      height: 4rem;
    }

    &:before {
      content: "";
      width: 9.5rem;
      height: 4rem;
      background-color: #d9d9d945;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}

.but {
  display: flex;
  justify-content: space-around;

  .van-button {
    width: 40%;
  }
}
</style>
